"use strict";
'use client';
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@mui/material/styles");
var _utils = require("@mui/material/utils");
var _base = require("@mui/base");
var _timelineDotClasses = require("./timelineDotClasses");
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var color = ownerState.color, variant = ownerState.variant, classes = ownerState.classes;
    var slots = {
        root: [
            'root',
            variant,
            color !== 'inherit' && "".concat(variant).concat((0, _utils.capitalize)(color))
        ]
    };
    return (0, _base.unstable_composeClasses)(slots, _timelineDotClasses.getTimelineDotUtilityClass, classes);
};
var TimelineDotRoot = (0, _styles.styled)('span', {
    name: 'MuiTimelineDot',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            styles[ownerState.color !== 'inherit' && "".concat(ownerState.variant).concat((0, _utils.capitalize)(ownerState.color))],
            styles[ownerState.variant]
        ];
    }
})(function(param) {
    var ownerState = param.ownerState, theme = param.theme;
    return _object_spread({
        display: 'flex',
        alignSelf: 'baseline',
        borderStyle: 'solid',
        borderWidth: 2,
        padding: 4,
        borderRadius: '50%',
        boxShadow: (theme.vars || theme).shadows[1],
        margin: '11.5px 0'
    }, ownerState.variant === 'filled' && _object_spread({
        borderColor: 'transparent'
    }, ownerState.color !== 'inherit' && _object_spread({}, ownerState.color === 'grey' ? {
        color: (theme.vars || theme).palette.grey[50],
        backgroundColor: (theme.vars || theme).palette.grey[400]
    } : {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    })), ownerState.variant === 'outlined' && _object_spread({
        boxShadow: 'none',
        backgroundColor: 'transparent'
    }, ownerState.color !== 'inherit' && _object_spread({}, ownerState.color === 'grey' ? {
        borderColor: (theme.vars || theme).palette.grey[400]
    } : {
        borderColor: (theme.vars || theme).palette[ownerState.color].main
    })));
});
var TimelineDot = /*#__PURE__*/ React.forwardRef(function TimelineDot(inProps, ref) {
    var props = (0, _styles.useThemeProps)({
        props: inProps,
        name: 'MuiTimelineDot'
    });
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'grey' : _props_color, _props_variant = props.variant, variant = _props_variant === void 0 ? 'filled' : _props_variant, other = _object_without_properties(props, [
        "className",
        "color",
        "variant"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        variant: variant
    });
    var classes = useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(TimelineDotRoot, _object_spread({
        className: (0, _clsx.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
process.env.NODE_ENV !== "production" ? TimelineDot.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * The content of the component.
   */ children: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The dot can have a different colors.
   * @default 'grey'
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'error',
            'grey',
            'info',
            'inherit',
            'primary',
            'secondary',
            'success',
            'warning'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The dot can appear filled or outlined.
   * @default 'filled'
   */ variant: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'filled',
            'outlined'
        ]),
        _propTypes.default.string
    ])
} : void 0;
var _default = exports.default = TimelineDot;
